export const DEFAULT_ENTITY_TYPE = 'Seller';

export const USER_MANAGEMENT_KEY = 'userManagement';
